import { Point } from '../model/point';
export class PointBuilder {
    static buildPoint(data) {
        let point = null;
        if (data) {
            point = new Point();
            point.id_client = data.id_client;
            point.date = data.date;
            point.points = data.points;
        }
        return point;
    }
    static buildPointPayload(point) {
        return {
            id_client: point.id_client,
            date: point.date,
            points: point.points
        };
    }
}
//# sourceMappingURL=point-builder.js.map